import {
  DiscordCategory,
  Platform,
  PrismaClient,
  TriggerStep,
} from "@prisma/client";
import { whenMatches } from "../../libs/tasks/src/lib/whenMatches";
import { TriggerCreate } from "../../libs/types/src";

const workspace = "f097583f-612e-415a-9744-eef292a1040e";
const communityId = "170662963504611328";
const alias = "prod-mobalytics";
const adminId = "752538623663931512";

export const tpcDevCategory: any[] = [
  {
    name: "Onboarding-1",
    type: "onboarding",
    guild: communityId,
    categoryId: "938453017408208907",
    workspace: workspace,
  },
  {
    name: "Onboarding-2",
    type: "onboarding",
    guild: communityId,
    categoryId: "938453018465161266",
    workspace: workspace,
  },
];

const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId,
  workspace,
};
export const tpcDevTrigger: TriggerCreate = {
  platform: "discord",
  name: "Mobalytics onboarding trigger",
  communityId,
  workspace,
  authorUserId: adminId,
  type: "team_join",
  steps: [
    {
      ...stepCommon,
      id: `${alias}-step0`,
      type: "create_channel",
      configs: {
        channelName: "onboard-{{user.username}}",
        userIds: ["{{user.id}}"],
        isPrivate: true,
        channelType: "onboarding",
      },
      transitions: [
        { targetStepId: `${alias}-send-initial-message-step` },
        { targetStepId: `${alias}-incomplete-delete` },
        { targetStepId: `${alias}-remind` },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-incomplete-delete`,
      type: "delete_channel",
      configs: {
        delaySeconds: 60 * 30,
        channelId: `{{${alias}-step0.channelId}}`,
      },
      transitions: [],
    },
    {
      id: `${alias}-remind`,
      type: "send_message",
      configs: {
        delaySeconds: 60 * 15,
        message:
          "Hey <@{{user.id}}>! You haven't quite finished onboarding. Please finish it before the channel closes in an hour!",
        channelId: `{{${alias}-step0.channelId}}`,
      },
      transitions: [],
    },
    {
      id: `${alias}-send-initial-message-step`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "Hey <@{{user.id}}>, welcome to the community! ",
      },
      transitions: [{ targetStepId: `${alias}-initial-question-step` }],
    },
    {
      ...stepCommon,
      id: `${alias}-initial-question-step`,
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "\n What brings you here?",
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "", id: "troubleshoot", label: "Troubleshoot" },
          { emoji: "", id: "community", label: "Community / Gaming" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-troubleshoot-step`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-initial-question-step.messageId}}`,
              buttonId: "troubleshoot",
            },
          },
        },
        {
          targetStepId: `${alias}-games-play-step`,

          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-initial-question-step.messageId}}`,
              buttonId: "community",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-troubleshoot-step`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message:
          "Please head to <#833432448141492224> channel to open a ticket!",
      },
      transitions: [{ targetStepId: `${alias}-check-continue` }],
    },
    {
      ...stepCommon,
      id: `${alias}-check-continue`,
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Do you want to answer a few more questions on games you play, so we can give you the right roles? \n`,
        type: "buttons",
        options: [
          { emoji: "✅", id: "yes", label: "Yes" },
          { emoji: "❌", id: "no", label: "No" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-games-play-step`,

          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-check-continue.messageId}}`,
              buttonId: "yes",
            },
          },
        },
        {
          targetStepId: `${alias}-end-message-step`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-check-continue.messageId}}`,
              buttonId: "no",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-games-play-step`,
      type: "send_multiple_select",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "\n What games do you play? Type skip to skip",
        doneButton: { label: "I'm all set" },
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "", id: "lol", label: "LoL" },
          { emoji: "", id: "tft", label: "TFT" },
          { emoji: "", id: "lor", label: "LoR" },
          { emoji: "", id: "wildrift", label: "Wild Rift" },
          { emoji: "", id: "destiny2", label: "Destiny 2" },
          { emoji: "", id: "valorant", label: "Valorant" },
          { emoji: "", id: "lostark", label: "Lost Ark" },

          //LoL, LoR, TFT, Valorant, Wild Rift, Destiny 2, Lost Ark
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-lol`,
          when: {
            // the user response will only be dispatched once the user completes the multi-selection.
            userResponse: {
              type: "multiple-select",
              userId: "{{user.id}}",
              messageId: `{{${alias}-games-play-step.messageId}}`,
            },
          },
        },
        {
          targetStepId: `${alias}-region-step`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    // {
    //   ...stepCommon,
    //   id: `${alias}-troubleshoot-roles`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["Support"],
    //     removeRoles: [],
    //   },
    //   transitions: [{ targetStepId: `${alias}-end-message-step` }],
    // },
    {
      id: `${alias}-role-lol`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "lol",
          },
        },
        elseStepId: `${alias}-role-tft`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["LoL"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-tft`,
        },
      ],
    },
    {
      id: `${alias}-role-tft`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "tft",
          },
        },
        elseStepId: `${alias}-role-lor`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-lor`,
        },
      ],
    },
    {
      id: `${alias}-role-lor`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "lor",
          },
        },
        elseStepId: `${alias}-role-wildrift`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["LoR"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-wildrift`,
        },
      ],
    },
    {
      id: `${alias}-role-wildrift`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "wildrift",
          },
        },
        elseStepId: `${alias}-role-destiny`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Wild Rift"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-destiny`,
        },
      ],
    },
    {
      id: `${alias}-role-destiny`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "destiny2",
          },
        },
        elseStepId: `${alias}-role-valorant`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["destiny"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-valorant`,
        },
      ],
    },
    {
      id: `${alias}-role-valorant`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "valorant",
          },
        },
        elseStepId: `${alias}-role-lostark`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Valorant"],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-lostark`,
        },
      ],
    },
    {
      id: `${alias}-role-lostark`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "lostark",
          },
        },
        elseStepId: `${alias}-step-lol`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Lost Ark"],
      },
      transitions: [
        {
          targetStepId: `${alias}-step-lol`,
        },
      ],
    },

    //===
    {
      id: `${alias}-step-lol`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "lol",
          },
        },
        elseStepId: `${alias}-step-tft`,
      },
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "\n Want to display your LoL rank? Type skip to skip",
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "", id: "iron", label: "Iron" },
          { emoji: "", id: "bronze", label: "Bronze" },
          { emoji: "", id: "silver", label: "Silver" },
          { emoji: "", id: "gold", label: "Gold" },
          { emoji: "", id: "platinum", label: "Platinum" },
          { emoji: "", id: "diamond", label: "Diamond" },
          { emoji: "", id: "master", label: "Master" },
          { emoji: "", id: "grandmaster", label: "Grandmaster" },
          { emoji: "", id: "challenger", label: "Challenger" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-lol-iron`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "iron",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-bronze`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "bronze",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-silver`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "silver",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-gold`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "gold",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-platinum`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "platinum",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-diamond`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "diamond",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-master`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "master",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-grandmaster`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "grandmaster",
            },
          },
        },
        {
          targetStepId: `${alias}-role-lol-challenger`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-lol.messageId}}`,
              buttonId: "challenger",
            },
          },
        },
        {
          targetStepId: `${alias}-step-tft`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-role-lol-iron`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Iron"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-bronze`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Bronze"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-silver`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Silver"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-gold`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Gold"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-platinum`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Platinum"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-diamond`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Diamond"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-master`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Master"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-grandmaster`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Grandmaster"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-role-lol-challenger`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Challenger"],
      },
      transitions: [{ targetStepId: `${alias}-step-tft` }],
    },
    {
      id: `${alias}-step-tft`,
      if: {
        condition: {
          "prod-mobalytics-games-play-step.userResponse.optionIds": {
            array_contains: "tft",
          },
        },
        elseStepId: `${alias}-region-step`,
      },
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "\n Want to display your TFT rank? Type skip to skip",
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "", id: "iron", label: "Iron" },
          { emoji: "", id: "bronze", label: "Bronze" },
          { emoji: "", id: "silver", label: "Silver" },
          { emoji: "", id: "gold", label: "Gold" },
          { emoji: "", id: "platinum", label: "Platinum" },
          { emoji: "", id: "diamond", label: "Diamond" },
          { emoji: "", id: "master", label: "Master" },
          { emoji: "", id: "grandmaster", label: "Grandmaster" },
          { emoji: "", id: "challenger", label: "Challenger" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-role-tft-iron`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "iron",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-bronze`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "bronze",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-silver`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "silver",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-gold`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "gold",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-platinum`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "platinum",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-diamond`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "diamond",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-master`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "master",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-grandmaster`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "grandmaster",
            },
          },
        },
        {
          targetStepId: `${alias}-role-tft-challenger`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step-tft.messageId}}`,
              buttonId: "challenger",
            },
          },
        },
        {
          targetStepId: `${alias}-region-step`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-role-tft-iron`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Iron"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-bronze`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Bronze"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-silver`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Silver"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-gold`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Gold"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-platinum`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Platinum"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-diamond`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Diamond"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-master`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Master"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-grandmaster`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Grandmaster"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      id: `${alias}-role-tft-challenger`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["TFT Challenger"],
      },
      transitions: [{ targetStepId: `${alias}-region-step` }],
    },
    {
      ...stepCommon,
      id: `${alias}-region-step`,
      type: "send_multiple_select",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "\n What is your region? Enter skip to skip.",
        type: "buttons", // by default it's "emojis"
        doneButton: { label: "I'm all set" },
        options: [
          { emoji: "🟢", id: "na", label: "NA" },
          { emoji: "⚪", id: "euw", label: "EUW" },
          { emoji: "🟣", id: "eune", label: "EUNE" },
          { emoji: "🟡", id: "oce", label: "OCE" },
          { emoji: "🟠", id: "other", label: "Other" },
        ],
      },
      transitions: [
        // {
        //   targetStepId: `${alias}-language-step`,
        //   when: {
        //     userResponse: {
        //       type: "message",
        //       channelId: `{{${alias}-step0.channelId}}`,
        //       userId: "{{user.id}}",
        //       content: "skip",
        //     },
        //   },
        // },
        {
          targetStepId: `${alias}-na`,
          when: {
            // the user response will only be dispatched once the user completes the multi-selection.
            userResponse: {
              type: "multiple-select",
              userId: "{{user.id}}",
              messageId: `{{${alias}-region-step.messageId}}`,
            },
          },
        },
        {
          targetStepId: `${alias}-language-step`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-na`,
      if: {
        condition: {
          "prod-mobalytics-region-step.userResponse.optionIds": {
            array_contains: "na",
          },
        },
        elseStepId: `${alias}-euw`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["NA"],
      },
      transitions: [
        {
          targetStepId: `${alias}-euw`,
        },
      ],
    },
    {
      id: `${alias}-euw`,
      if: {
        condition: {
          "prod-mobalytics-region-step.userResponse.optionIds": {
            array_contains: "euw",
          },
        },
        elseStepId: `${alias}-eune`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["EUW"],
      },
      transitions: [
        {
          targetStepId: `${alias}-eune`,
        },
      ],
    },
    {
      id: `${alias}-eune`,
      if: {
        condition: {
          "prod-mobalytics-region-step.userResponse.optionIds": {
            array_contains: "eune",
          },
        },
        elseStepId: `${alias}-oce`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["EUNE"],
      },
      transitions: [
        {
          targetStepId: `${alias}-oce`,
        },
      ],
    },
    {
      id: `${alias}-oce`,
      if: {
        condition: {
          "prod-mobalytics-region-step.userResponse.optionIds": {
            array_contains: "oce",
          },
        },
        elseStepId: `${alias}-other`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["OCE"],
      },
      transitions: [
        {
          targetStepId: `${alias}-other`,
        },
      ],
    },
    {
      id: `${alias}-other`,
      if: {
        condition: {
          "prod-mobalytics-region-step.userResponse.optionIds": {
            array_contains: "other",
          },
        },
        elseStepId: `${alias}-language-step`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Other"],
      },
      transitions: [
        {
          targetStepId: `${alias}-language-step`,
        },
      ],
    },

    // //-------
    // {
    //   id: `${alias}-role-na`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["NA"],
    //   },
    //   transitions: [{ targetStepId: `${alias}-language-step` }],
    // },
    // {
    //   id: `${alias}-role-euw`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["EUW"],
    //   },
    //   transitions: [{ targetStepId: `${alias}-language-step` }],
    // },
    // {
    //   id: `${alias}-role-eune`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["EUNE"],
    //   },
    //   transitions: [{ targetStepId: `${alias}-language-step` }],
    // },
    // {
    //   id: `${alias}-role-oce`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["OCE"],
    //   },
    //   transitions: [{ targetStepId: `${alias}-language-step` }],
    // },
    // {
    //   id: `${alias}-role-other`,
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["Other"],
    //   },
    //   transitions: [{ targetStepId: `${alias}-language-step` }],
    // },
    {
      ...stepCommon,
      id: `${alias}-language-step`,
      type: "send_multiple_select",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message:
          "\n  Do you want to join channels for your respective languages?  Enter skip to skip.",
        type: "buttons", // by default it's "emojis"
        doneButton: { label: "I'm all set" },
        options: [
          { emoji: "", id: "cestina", label: "čeština" },
          { emoji: "", id: "dutch", label: "Deutsch" },
          { emoji: "", id: "enn", label: "Ελληνικά" },
          { emoji: "", id: "spanish", label: "Español" },
          { emoji: "", id: "french", label: "Français" },
          { emoji: "", id: "magyar", label: "Magyar" },
          { emoji: "", id: "italiano", label: "Italiano" },
          { emoji: "", id: "korean", label: "한국어" },
          { emoji: "", id: "polish", label: "Polski" },
          { emoji: "", id: "portuguse", label: "Português" },
          { emoji: "", id: "roman", label: "Română" },
          { emoji: "", id: "py", label: "Русский" },
          { emoji: "", id: "turkush", label: "Türkçe" },
          { emoji: "", id: "chinese", label: "简体中文" },
          { emoji: "", id: "urdu", label: "عربى" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-cestina`,
          when: {
            // the user response will only be dispatched once the user completes the multi-selection.
            userResponse: {
              type: "multiple-select",
              userId: "{{user.id}}",
              messageId: `{{${alias}-language-step.messageId}}`,
            },
          },
        },
        {
          targetStepId: `${alias}-end-message-step`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-cestina`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "cestina",
          },
        },
        elseStepId: `${alias}-dutch`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["čeština"],
      },
      transitions: [
        {
          targetStepId: `${alias}-dutch`,
        },
      ],
    },
    {
      id: `${alias}-dutch`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "dutch",
          },
        },
        elseStepId: `${alias}-enn`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Deutsch"],
      },
      transitions: [
        {
          targetStepId: `${alias}-enn`,
        },
      ],
    },
    {
      id: `${alias}-enn`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "enn",
          },
        },
        elseStepId: `${alias}-spanish`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Ελληνικά"],
      },
      transitions: [
        {
          targetStepId: `${alias}-spanish`,
        },
      ],
    },
    {
      id: `${alias}-spanish`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "spanish",
          },
        },
        elseStepId: `${alias}-french`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Español"],
      },
      transitions: [
        {
          targetStepId: `${alias}-french`,
        },
      ],
    },
    {
      id: `${alias}-french`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "french",
          },
        },
        elseStepId: `${alias}-magyar`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Français"],
      },
      transitions: [
        {
          targetStepId: `${alias}-magyar`,
        },
      ],
    },
    {
      id: `${alias}-magyar`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "magyar",
          },
        },
        elseStepId: `${alias}-italiano`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Magyar"],
      },
      transitions: [
        {
          targetStepId: `${alias}-italiano`,
        },
      ],
    },
    {
      id: `${alias}-italiano`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "italiano",
          },
        },
        elseStepId: `${alias}-korean`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Italiano"],
      },
      transitions: [
        {
          targetStepId: `${alias}-korean`,
        },
      ],
    },
    {
      id: `${alias}-korean`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "korean",
          },
        },
        elseStepId: `${alias}-polish`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["한국어"],
      },
      transitions: [
        {
          targetStepId: `${alias}-polish`,
        },
      ],
    },
    {
      id: `${alias}-polish`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "polish",
          },
        },
        elseStepId: `${alias}-portuguse`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Polski"],
      },
      transitions: [
        {
          targetStepId: `${alias}-portuguse`,
        },
      ],
    },
    {
      id: `${alias}-portuguse`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "portuguse",
          },
        },
        elseStepId: `${alias}-roman`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Português"],
      },
      transitions: [
        {
          targetStepId: `${alias}-roman`,
        },
      ],
    },
    {
      id: `${alias}-roman`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "roman",
          },
        },
        elseStepId: `${alias}-py`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Română"],
      },
      transitions: [
        {
          targetStepId: `${alias}-py`,
        },
      ],
    },
    {
      id: `${alias}-py`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "py",
          },
        },
        elseStepId: `${alias}-turkish`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Русский"],
      },
      transitions: [
        {
          targetStepId: `${alias}-turkish`,
        },
      ],
    },

    {
      id: `${alias}-turkish`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "turkish",
          },
        },
        elseStepId: `${alias}-chinese`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Türkçe"],
      },
      transitions: [
        {
          targetStepId: `${alias}-chinese`,
        },
      ],
    },
    {
      id: `${alias}-chinese`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "chinese",
          },
        },
        elseStepId: `${alias}-urdu`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["简体中文"],
      },
      transitions: [
        {
          targetStepId: `${alias}-urdu`,
        },
      ],
    },
    {
      id: `${alias}-urdu`,
      if: {
        condition: {
          "prod-mobalytics-language-step.userResponse.optionIds": {
            array_contains: "urdu",
          },
        },
        elseStepId: `${alias}-end-message-step`,
      },
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["عربى"],
      },
      transitions: [
        {
          targetStepId: `${alias}-end-message-step`,
        },
      ],
    },

    ///----------------------------------------
    {
      id: `${alias}-end-message-step`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\nThank you for joining us! This channel will be auto deleted in 5 minutes.`,
      },
      transitions: [{ targetStepId: `${alias}-cancel-reminder` }],
    },
    {
      id: `${alias}-cancel-reminder`,
      type: "cancel_tasks",
      configs: {
        invocationIds: [`{{invocationIds.${alias}-remind}}`],
      },
      transitions: [{ targetStepId: `${alias}-cancel-incomplete-delete` }],
    },
    {
      id: `${alias}-cancel-incomplete-delete`,
      type: "cancel_tasks",
      configs: {
        invocationIds: [`{{invocationIds.${alias}-incomplete-delete}}`],
      },
      transitions: [{ targetStepId: `${alias}-delete-channel` }],
    },
    {
      ...stepCommon,
      id: `${alias}-delete-channel`,
      type: "delete_channel",
      configs: {
        delaySeconds: 60 * 5,
        channelId: `{{${alias}-step0.channelId}}`,
      },
      transitions: [],
    },
  ],
};

export { tpcDevTrigger as trigger, tpcDevCategory as categories };
